import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#0597A3" d="M82.85 26.7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="m103.38 33.25 3.94-3.94c.59-.59.59-1.54 0-2.12a1.49 1.49 0 0 0-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0 1.49 1.49 0 0 0 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM49.44 96.77a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M19.49 29.77h-5.57V24.2c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57H5.35c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M23.08 102.77c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4a4 4 0 1 0 8 0c0-2.21-1.79-4-4-4"
    />
    <path
      fill="#001A43"
      d="M79.81 40.06c-7.57-9.17-20.18-12.63-31.37-8.61-11.09 3.98-18.57 14.52-18.71 26.29l-4.09-4.09a3 3 0 0 0-4.24 0 3 3 0 0 0 0 4.24l9.19 9.19c.59.59 1.35.88 2.12.88s1.54-.29 2.12-.88l9.2-9.19a3 3 0 0 0 0-4.24 3 3 0 0 0-4.24 0l-4.06 4.06c.15-9.23 6.03-17.49 14.74-20.61 8.82-3.17 18.75-.44 24.72 6.79a2.99 2.99 0 0 0 4.22.4 2.99 2.99 0 0 0 .4-4.22z"
    />
    <path
      fill="#00D8D8"
      d="m94.6 60.54-9.19-9.19a2.993 2.993 0 0 0-4.24 0l-9.19 9.19a3 3 0 0 0 0 4.24 3 3 0 0 0 4.24 0l3.88-3.88c-1.01 7.99-6.22 14.83-13.87 17.87-8.54 3.39-18.13 1.27-24.44-5.42a2.99 2.99 0 0 0-4.24-.12 2.99 2.99 0 0 0-.12 4.24c5.47 5.8 12.9 8.9 20.51 8.9 3.52 0 7.08-.66 10.5-2.02 10.05-3.99 16.79-13.15 17.72-23.76l4.2 4.2c.59.59 1.35.88 2.12.88s1.54-.29 2.12-.88a3 3 0 0 0 0-4.24z"
    />
  </svg>
);
const SvgEnrichedIconSyncInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconSyncInverted);
export default Memo;
